// app contants
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const VALID_COMPANY = 'VALID_COMPANY';
export const UPDATE_DATE_FORMAT = 'UPDATE_DATE_FORMAT';

// AUTH CONSTANTS ===============================================================================
export const SIGNIN = 'SIGNIN';
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';
export const SIGNIN_FAILURE = 'SIGNIN_FAILURE';

export const EMAIL_VERIFICATION = 'EMAIL_VERIFICATION';
export const EMAIL_VERIFICATION_SUCCESS = 'EMAIL_VERIFICATION_SUCCESS';
export const EMAIL_VERIFICATION_FAILURE = 'EMAIL_VERIFICATION_FAILURE';

export const OTP_VERIFICATION = 'OTP_VERIFICATION';
export const OTP_VERIFICATION_SUCCESS = 'OTP_VERIFICATION_SUCCESS';
export const OTP_VERIFICATION_FAILURE = 'OTP_VERIFICATION_FAILURE';

export const PASSWORD_RESET = 'PASSWORD_RESET';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

// COMPANY ONBAORDING ==================================================================================

export const ONBOARD_COMPANY = 'ONBOARD_COMPANY';
export const COMPANY_ONBOARD_SUCCESS = 'COMPANY_ONBOARD_SUCCESS';
export const COMPANY_ONBOARD_FAILURE = 'COMPANY_ONBOARD_FAILURE';

export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTIONS';
export const GET_SUBSCRIPTIONS_SUCCESS = 'GET_SUBSCRIPTIONS_SUCCESS';
export const GET_SUBSCRIPTIONS_FAILURE = 'GET_SUBSCRIPTIONS_FAILURE';

export const CREATE_SUBSCRIPTION_SESSION = 'CREATE_SUBSCRIPTION_SESSION';

// USERS MANAGEMENT CONSTANTS =============================================================================
export const GET_USERS = 'GET_USERS';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE';

export const ADD_USER = 'ADD_USER';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_FAILURE = 'ADD_USER_FAILURE';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const GET_USER_DETAIL = 'GET_USER_DETAIL';
export const GET_USER_DETAIL_SUCCESS = 'GET_USER_DETAIL_SUCCESS';
export const GET_USER_DETAIL_FAILURE = 'GET_USER_DETAIL_FAILURE';

export const USER_DETAIL_RESET = 'USER_DETAIL_RESET';

export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS';
export const UPDATE_USER_STATUS_SUCCESS = 'UPDATE_USER_STATUS_SUCCESS';
export const UPDATE_USER_STATUS_FAILURE = 'UPDATE_USER_STATUS_FAILURE';

//site-management
export const GET_PROPERTY = 'GET_PROPERTY';
export const GET_PROPERTY_SUCCESS = 'GET_PROPERTY_SUCCESS';
export const GET_PROPERTY_FAILURE = 'GET_PROPERTY_FAILURE';

export const UPDATE_PROPERTY_STATUS = 'GET_PROPERTY_STATUS';

export const GET_PROPERTY_DETAIL = 'GET_PROPERTY_DETAIL';
export const GET_PROPERTY_DETAIL_SUCCESS = 'GET_PROPERTY_DETAIL_SUCCESS';
export const GET_PROPERTY_DETAIL_FAILURE = 'GET_PROPERTY_DETAIL_FAILURE';

export const ADD_PROPERTY = 'ADD_PROPERTY_DETAIL';
export const ADD_PROPERTY_SUCCESS = 'ADD_PROPERTY_SUCCESS';
export const ADD_PROPERTY_FAILURE = 'ADD_PROPERTY_FAILURE';

export const EDIT_PROPERTY = 'EDIT_PROPERTY';
export const EDIT_PROPERTY_SUCCESS = 'EDIT_PROPERTY_SUCCESS';
export const EDIT_PROPERTY_FAILURE = 'EDIT_PROPERTY_FAILURE';

export const GET_PROPERTIES = 'GET_PROPERTIES';
export const GET_PROPERTIES_SUCCESS = 'GET_PROPERTIES_SUCCESS';
export const GET_PROPERTIES_FAILURE = 'GET_PROPERTIES_FAILURE';

export const ADD_ADDRESS = 'ADD_ADDRESS';
export const EDIT_ADDRESS = 'EDIT_ADDRESS';

export const GET_ADDRESS = 'GET_ADDRESS';
export const GET_ADDRESS_SUCCESS = 'GET_ADDRESS_SUCCESS';
export const GET_ADDRESS_FAILURE = 'GET_ADDRESS_FAILURE';
export const GET_ADDRESS_DATA_CLEANER = 'GET_ADDRESS_DATA_CLEANER';

export const ADD_DOCUMENT = 'ADD_DOCUMENT';
export const EDIT_DOCUMENT = 'EDIT_DOCUMENT';

export const GET_DOCUMENT = 'GET_DOCUMENT';
export const GET_DOCUMENT_SUCCESS = 'GET_DOCUMENT_SUCCESS';
export const GET_DOCUMENT_FAILURE = 'GET_DOCUMENT_FAILURE';
export const GET_DOCUMENT_DATA_CLEANER = 'GET_DOCUMENT_DATA_CLEANER';

export const ADD_LOCATION = 'ADD_LOCATION';
export const EDIT_LOCATION = 'EDIT_LOCATION';
export const GET_LOCATIONS = 'GET_LOCATIONS';
export const GET_LOCATIONS_SUCCESS = 'GET_LOCATIONS_SUCCESS';
export const GET_LOCATIONS_FAILURE = 'GET_LOCATIONS_FAILURE';
export const LOCATION_DATA_CLEANER = 'LOCATION_DATA_CLEANER';

export const ADD_INCIDENT = 'ADD_INCIDENT';
export const EDIT_INCIDENT = 'EDIT_INCIDENT';

export const GET_INCIDENT_TYPES = 'GET_INCIDENT_TYPES';
export const GET_INCIDENT_TYPES_SUCCESS = 'GET_INCIDENT_TYPES_SUCCESS';
export const GET_INCIDENT_TYPES_FAILURE = 'GET_INCIDENT_TYPES_FAILURE';
export const ADD_PROPERTY_INCIDENT = 'ADD_PROPERTY_INCIDENT';
export const ADD_PROPERTY_INCIDENT_SUCCESS = 'ADD_PROPERTY_INCIDENT_SUCCESS';
export const ADD_PROPERTY_INCIDENT_FAILURE = 'ADD_PROPERTY_INCIDENT_FAILURE';

// ==================== report management =============================
export const GENERATE_REPORT = 'GENERATE_REPORT';
export const GENERATE_REPORT_SUCCESS = 'GENERATE_REPORT_SUCCESS';
export const GENERATE_REPORT_FAILURE = 'GENERATE_REPORT_FAILURE';

export const ADD_CHECKPOINT = 'ADD_CHECKPOINT';
export const EDIT_CHECKPOINT = 'EDIT_CHECKPOINT';

export const GET_CHECKPOINTS = 'GET_CHECKPOINTS';
export const GET_CHECKPOINTS_SUCCESS = 'GET_CHECKPOINTS_SUCCESS';
export const GET_CHECKPOINTS_FAILURE = 'GET_CHECKPOINTS_FAILURE';
export const GET_CHECKPOINTS_CLEANER = 'GET_CHECKPOINTS_CLEANER';

export const ADD_GEOFENCE = 'ADD_GEOFENCE';
export const EDIT_GEOFENCE = 'EDIT_GEOFENCE';

export const GET_GEOFENCE = 'GET_GEOFENCE';
export const GET_GEOFENCE_SUCCESS = 'GET_GEOFENCE_SUCCESS';
export const GET_GEOFENCE_FAILURE = 'GET_GEOFENCE_FAILURE';
export const GET_GEOFENCE_DATA_CLEANER = 'GET_GEOFENCE_DATA_CLEANER';

export const ADD_PHONE = 'ADD_PHONE';
export const EDIT_PHONE = 'EDIT_PHONE';

export const ADD_ADDRESS_TYPE = 'ADD_ADDRESS_TYPE';
export const ADD_ADDRESS_TYPE_SUCCESS = 'ADD_ADDRESS_TYPE_SUCCESS';

// Client Management
export const GET_INVITED_CLIENTS = 'GET_INVITED_CLIENTS';
export const GET_INVITED_CLIENTS_SUCCESS = 'GET_INVITED_CLIENTS_SUCCESS';
export const GET_INVITED_CLIENTS_FAILURE = 'GET_INVITED_CLIENTS_FAILURE';

export const GET_INVITED_CLIENT_DETAIL = 'GET_INVITED_CLIENT_DETAIL';
export const GET_INVITED_CLIENT_DETAIL_SUCCESS =
    'GET_INVITED_CLIENT_DETAIL_SUCCESS';
export const GET_INVITED_CLIENT_DETAIL_FAILURE =
    'GET_INVITED_CLIENT_DETAIL_FAILURE';

export const GET_COMPANIES = 'GET_COMPANIES';
export const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS';
export const GET_COMPANIES_FAILURE = 'GET_COMPANIES_FAILURE';

export const GET_COMPANIES_DETAIL = 'GET_COMPANIES_DETAIL';
export const GET_COMPANIES_DETAIL_SUCCESS = 'GET_COMPANIES_DETAIL_SUCCESS';
export const GET_COMPANIES_DETAIL_FAILURE = 'GET_COMPANIES_DETAIL_FAILURE';

export const COMPANIES_STATUS_UPDATE = 'COMPANIES_STATUS_UPDATE';
export const COMPANIES_STATUS_UPDATE_SUCCESS =
    'COMPANIES_STATUS_UPDATE_SUCCESS';
export const COMPANIES_STATUS_UPDATE_FAILURE =
    'COMPANIES_STATUS_UPDATE_FAILURE';

// Settings
export const GET_SCHEDULES = 'GET_SCHEDULES';
export const GET_SCHEDULES_SUCCESS = 'GET_SCHEDULES_SUCCESS';
export const GET_SCHEDULES_FAILURE = 'GET_SCHEDULES_FAILURE';

export const GET_SCHEDULES_DETAIL = 'GET_SCHEDULES_DETAIL';
export const GET_SCHEDULES_DETAIL_SUCCESS = 'GET_SCHEDULES_DETAIL_SUCCESS';
export const GET_SCHEDULES_DETAIL_FAILURE = 'GET_SCHEDULES_DETAIL_FAILURE';

export const GET_ELEGIBILITIES = 'GET_ELEGIBILITIES';
export const GET_ELEGIBILITIES_SUCCESS = 'GET_ELEGIBILITIES_SUCCESS';
export const GET_ELEGIBILITIES_FAILURE = 'GET_ELEGIBILITIES_FAILURE';

export const LOADER_TRUE = 'LOADER_TRUE';
export const LOADER_FALSE = 'LOADER_FALSE';

// MANAGE INCIDENTS
export const GET_MANAGE_INCIDENTS = 'GET_MANAGE_INCIDENTS';
export const GET_MANAGE_INCIDENTS_SUCCESS = 'GET_MANAGE_INCIDENTS_SUCCESS';
export const GET_MANAGE_INCIDENTS_FAILURE = 'GET_MANAGE_INCIDENTS_FAILURE';

export const GET_MANAGE_INCIDENTS_DETAIL = 'GET_MANAGE_INCIDENTS_DETAIL';
export const GET_MANAGE_INCIDENTS_DETAIL_SUCCESS =
    'GET_MANAGE_INCIDENTS_DETAIL_SUCCESS';
export const GET_MANAGE_INCIDENTS_DETAIL_FAILURE =
    'GET_MANAGE_INCIDENTS_DETAIL_FAILURE';

export const GET_ASSIGN_INCIDENT_DETAIL = 'GET_ASSIGN_INCIDENT_DETAIL';
export const GET_ASSIGN_INCIDENT_DETAIL_SUCCESS =
    'GET_ASSIGN_INCIDENT_DETAIL_SUCCESS';
export const GET_ASSIGN_INCIDENT_DETAIL_FAILURE =
    'GET_ASSIGN_INCIDENT_DETAIL_FAILURE';
export const GET_ASSIGN_INCIDENT_DETAIL_CLEANER =
    'GET_ASSIGN_INCIDENT_DETAIL_CLEANER';

// SHIFT SCHEDULING
export const GET_POTENTIAL_TAKERS = 'GET_POTENTIAL_TAKERS';
export const GET_POTENTIAL_TAKERS_SUCCESS = 'GET_POTENTIAL_TAKERS_SUCCESS';
export const GET_POTENTIAL_TAKERS_FAILURE = 'GET_POTENTIAL_TAKERS_FAILURE';

export const GET_SHIFTS = 'GET_SHIFTS';
export const GET_SHIFTS_SUCCESS = 'GET_SHIFTS_SUCCESS';
export const GET_SHIFTS_FAILURE = 'GET_SHIFTS_FAILURE';

export const CLEAR_SHIFTS = 'CLEAR_SHIFTS';

//MY SHIFTS
export const GET_MY_SHIFT = 'GET_MY_SHIFT';
export const GET_MY_SHIFT_SUCCESS = 'GET_MY_SHIFT_SUCCESS';
export const GET_MY_SHIFT_FAILURE = 'GET_MY_SHIFT_FAILURE';

// Attendence Management
export const GET_ATTENDENCE = 'GET_ATTENDENCE';
export const GET_ATTENDENCE_SUCCESS = 'GET_ATTENDENCE_SUCCESS';
export const GET_ATTENDENCE_FAILURE = 'GET_ATTENDENCE_FAILURE';

export const GET_ATTENDENCE_PROPERTIES = 'GET_ATTENDENCE_PROPERTIES';
export const GET_ATTENDENCE_PROPERTIES_SUCCESS =
    'GET_ATTENDENCE_PROPERTIES_SUCCESS';
export const GET_ATTENDENCE_PROPERTIES_FAILURE =
    'GET_ATTENDENCE_PROPERTIES_FAILURE';

export const GET_ATTENDENCE_SCHEDULES = 'GET_ATTENDENCE_SCHEDULES';
export const GET_ATTENDENCE_SCHEDULES_SUCCESS =
    'GET_ATTENDENCE_SCHEDULES_SUCCESS';
export const GET_ATTENDENCE_SCHEDULES_FAILURE =
    'GET_ATTENDENCE_SCHEDULES_FAILURE';

export const GET_ATTENDENCE_USERS = 'GET_ATTENDENCE_USERS';
export const GET_ATTENDENCE_USERS_SUCCESS = 'GET_ATTENDENCE_USERS_SUCCESS';
export const GET_ATTENDENCE_USERS_FAILURE = 'GET_ATTENDENCE_USERS_FAILURE';

export const CLEAR_ATTENDENCE_FILTER = 'CLEAR_ATTENDENCE_FILTER';
export const CLEAR_ATTENDENCE = 'CLEAR_ATTENDENCE';

// Attendance Management v2 - sidebar users + user-based fetch
export const GET_SIDEBAR_USERS = 'GET_SIDEBAR_USERS';
export const GET_SIDEBAR_USERS_SUCCESS = 'GET_SIDEBAR_USERS_SUCCESS';
export const GET_SIDEBAR_USERS_FAILURE = 'GET_SIDEBAR_USERS_FAILURE';
export const GET_ATTENDENCE_BY_USER = 'GET_ATTENDENCE_BY_USER';

// Attendance Approval
export const APPROVE_ATTENDANCE = 'APPROVE_ATTENDANCE';
export const APPROVE_ATTENDANCE_SUCCESS = 'APPROVE_ATTENDANCE_SUCCESS';
export const APPROVE_ATTENDANCE_FAILURE = 'APPROVE_ATTENDANCE_FAILURE';

// Week Configuration
export const UPDATE_WEEK_CONFIG = 'UPDATE_WEEK_CONFIG';

//TOR
export const GET_TOR = 'GET_TOR';
export const GET_TOR_SUCCESS = 'GET_TOR_SUCCESS';
export const GET_TOR_FAILURE = 'GET_TOR_FAILURE';

export const GET_TOR_DETAIL = 'GET_TOR_DETAIL';
export const GET_TOR_DETAIL_SUCCESS = 'GET_TOR_DETAIL_SUCCESS';
export const GET_TOR_DETAIL_FAILURE = 'GET_TOR_DETAIL_FAILURE';

//DropOrSwap
export const GET_DROP_OR_SWAP = 'GET_DROP_OR_SWAP';
export const GET_DROP_OR_SWAP_SUCCESS = 'GET_DROP_OR_SWAP_SUCCESS';
export const GET_DROP_OR_SWAP_FAILURE = 'GET_DROP_OR_SWAP_FAILURE';

export const GET_DROP_OR_SWAP_DETAIL = 'GET_DROP_OR_SWAP_DETAIL';
export const GET_DROP_OR_SWAP_DETAIL_SUCCESS =
    'GET_DROP_OR_SWAP_DETAIL_SUCCESS';
export const GET_DROP_OR_SWAP_DETAIL_FAILURE =
    'GET_DROP_OR_SWAP_DETAIL_FAILURE';

// AlertManagement
export const GET_ALERTS = 'GET_ALERTS';
export const GET_ALERTS_SUCCESS = 'GET_ALERTS_SUCCESS';
export const GET_ALERTS_FAILURE = 'GET_ALERTS_FAILURE';

export const GET_ALERT_DETAIL = 'GET_ALERT_DETAIL';
export const GET_ALERT_DETAIL_SUCCESS = 'GET_ALERT_DETAIL_SUCCESS';
export const GET_ALERT_DETAIL_FAILURE = 'GET_ALERT_DETAIL_FAILURE';

export const GET_CURRENT_USER = 'GET_CURRENT_USER';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';
export const GET_CURRENT_USER_FAILURE = 'GET_CURRENT_USER_FAILURE';

export const EDIT_CURRENT_USER = 'EDIT_CURRENT_USER';
export const EDIT_CURRENT_USER_SUCCESS = 'EDIT_CURRENT_USER_SUCCESS';
export const EDIT_CURRENT_USER_FAILURE = 'EDIT_CURRENT_USER_FAILURE';

export const ADD_ALERT = 'ADD_ALERT';
export const ADD_ALERT_SUCCESS = 'ADD_ALERT_SUCCESS';
export const ADD_ALERT_FAILURE = 'ADD_ALERT_FAILURE';

export const UPDATE_ALERT = 'UPDATE_ALERT';
export const UPDATE_ALERT_SUCCESS = 'UPDATE_ALERT_SUCCESS';
export const UPDATE_ALERT_FAILURE = 'UPDATE_ALERT_FAILURE';

export const UPDATE_ALERT_STATUS = 'UPDATE_ALERT_STATUS';
export const UPDATE_ALERT_STATUS_SUCCESS = 'UPDATE_ALERT_STATUS_SUCCESS';
export const UPDATE_ALERT_STATUS_FAILURE = 'UPDATE_ALERT_STATUS_FAILURE';

export const ALERT_DETAIL_RESET = 'ALERT_DETAIL_RESET';

export const ACCEPTED_IMAGE_TYPES = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/webp',
];

export const DATA_UPDATE = 'DATA_UPDATE';
export const MAX_FILE_SIZE = 5000000;

// notification handling
export const NOTIFICATION_TRIGGER = 'NOTIFICATION_TRIGGER';
export const NOTIFICATION_CLEAR = 'NOTIFICATION_CLEAR';
export const SET_NOTIFICATION_COUNT = 'SET_NOTIFICATION_COUNT';
export const SET_CHAT_CHANNEL_ID = 'SET_CHAT_CHANNEL_ID'

export const GENERAL_LOADER = 'GENERAL_LOADER'

export const ADD_AVAILABILITY = 'ADD_AVAILABILITY';
export const ADD_AVAILABILITY_SUCCESS = 'ADD_AVAILABILITY_SUCCESS';
export const ADD_AVAILABILITY_FAILURE = 'ADD_AVAILABILITY_FAILURE';

export const GET_AVAILABILITY = 'GET_AVAILABILITY';
export const GET_AVAILABILITY_SUCCESS = 'GET_AVAILABILITY_SUCCESS';
export const GET_AVAILABILITY_FAILURE = 'GET_AVAILABILITY_FAILURE';

export const DELETE_AVAILABILITY = 'DELETE_AVAILABILITY';
export const DELETE_AVAILABILITY_SUCCESS = 'DELETE_AVAILABILITY_SUCCESS';
export const DELETE_AVAILABILITY_FAILURE = 'DELETE_AVAILABILITY_FAILURE';

export const UPDATE_AVAILABILITY = 'UPDATE_AVAILABILITY';
export const UPDATE_AVAILABILITY_SUCCESS = 'UPDATE_AVAILABILITY_SUCCESS';
export const UPDATE_AVAILABILITY_FAILURE = 'UPDATE_AVAILABILITY_FAILURE';